import React, { useEffect, useState } from 'react';
import Layout from './components/Layout';
import WithdrawalTable from './components/WithdrawalTable';
import axios from 'axios';
import WithdrawalStatusUpdateDialog from './components/WithdrawalStatusUpdateDialog';
import CloseIcon from '@mui/icons-material/Close';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
const SDM_PAY_HOST = process.env.REACT_APP_SDM_PAY_BE
interface WithdrawalData {
    amount: string;
    createdAt: string;
    currency: string;
    id: string;
    note: string;
    reference: string | null;
    settledAt: string | null;
    status: string;
    updatedAt: string;
    userId: string;
}
interface ClientData {
    Withdrawals: Array<WithdrawalData>;
    cad_balance: number;
    createdAt: string;
    email: string;
    id: string;
    nickname: string;
    updatedAt: string;
    usd_balance: number;
    usdc_wallet: string;
    usdt_wallet: string;
}
function Withdrawal({isAdmin}: any) {
    const [data, setData] = useState<ClientData[]>([])
    const [openStatusUpdate, setOpenStatusUpdate] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState<WithdrawalData>();
    const [update, setUpdate] = useState(0);
    const [searchTXValue, setSearchTXValue] = useState(''); 
    useEffect(() => {
        getWithdrawalReuests()
    },[update, searchTXValue])
    const getWithdrawalReuests = async() : Promise<any[]> => {
        try {
            // create sig

            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const path = '/api/getB2C2Trades' 

            // const signature = generateSignature("GET", timeStamp, path, null, null) 
            // console.log("get b2c2 trades sig", signature)

            const result = await axios.post(SDM_PAY_HOST + '/adminGetWithdrawals')
            console.log(result)
            let resultJSONData = result.data
            console.log(resultJSONData)
            if(searchTXValue){
                console.log(searchTXValue)
                resultJSONData = resultJSONData.filter((user:any) => user.email.toUpperCase().includes(searchTXValue.toUpperCase()))
                console.log(resultJSONData)
            }
            setData(resultJSONData)
            return resultJSONData
        }
        catch (err) {
            alert(err)
            return []
        }
    }
    const handleSelectRequestToUpdate = (request: WithdrawalData) => {
        setSelectedRequest(request)
        setOpenStatusUpdate(true)
    }
    const handleSearchTXclient = (e:any) => {
        let inputValue = (e.target.value).trim()
        setSearchTXValue(inputValue)
    }
    const handleClickClearTransactionSearchInput = () => {
        setSearchTXValue('')
    }
    return (
        <Layout>
            <div style={{width: '100%',marginTop: 30}}>
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 200, height: 36 ,marginBottom: 1, marginRight: 5 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        value={searchTXValue}
                        onChange={(e) => handleSearchTXclient(e)}
                        placeholder="Search User"
                        inputProps={{ 'aria-label': 'search client' }}
                        endAdornment={searchTXValue? 
                            <InputAdornment position="end">
                                <IconButton
                                    size='small'
                                    onClick={handleClickClearTransactionSearchInput}
                                    style={{borderRadius: 0}}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </InputAdornment> : <SearchIcon />}
                    />
                </Paper>
                <WithdrawalTable data={data} update={update} setUpdate={setUpdate} handleSelectRequestToUpdate={handleSelectRequestToUpdate} isAdmin={isAdmin}/>
                {selectedRequest && <WithdrawalStatusUpdateDialog open={openStatusUpdate} handleClose={() => setOpenStatusUpdate(false)} withdrawalRequest={selectedRequest} update={update} setUpdate={setUpdate}/>}
            </div>
        </Layout>
    );
}

export default Withdrawal;